import { render, staticRenderFns } from "./boolean-switch.vue?vue&type=template&id=70e4aebb&"
import script from "./boolean-switch.vue?vue&type=script&lang=ts&"
export * from "./boolean-switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e4aebb')) {
      api.createRecord('70e4aebb', component.options)
    } else {
      api.reload('70e4aebb', component.options)
    }
    module.hot.accept("./boolean-switch.vue?vue&type=template&id=70e4aebb&", function () {
      api.rerender('70e4aebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/boolean-switch.vue"
export default component.exports